<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">{{ pageTitle }}</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="notice-card" v-if="notice.title || notice.content">
        <h2>{{ notice.title || pageTitle }}</h2>
        <div class="notice-content rich-text" v-html="safeContent"></div>
        <time>时间：{{ formatTime(notice.publishTime || notice.created_at) }}</time>
      </section>
      <div v-else class="doge-empty">{{ pageTitle }}不存在或已下线</div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'newsDetail',
  data() { return { notice: { title: this.$route.query.title || '', content: '' } }; },
  computed: {
    pageTitle() { return this.$route.query.pageTitle || '公告'; },
    safeContent() {
      return this.sanitizeHtml(this.notice.content || this.notice.desc || this.notice.summary || '暂无资讯内容');
    }
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        const r = await this.$axios.get('/api/news/info', { params: { id: this.$route.query.id } });
        this.notice = (r.data && r.data.data) || {};
      } catch (e) {
        this.notice = this.notice.title ? this.notice : {};
      }
    },
    sanitizeHtml(value) {
      const box = document.createElement('div');
      box.innerHTML = String(value || '');
      box.querySelectorAll('script,style,iframe,object,embed,link,meta').forEach(el => el.remove());
      box.querySelectorAll('*').forEach(el => {
        Array.from(el.attributes).forEach(attr => {
          const name = attr.name.toLowerCase();
          const val = String(attr.value || '').trim().toLowerCase();
          if (name.startsWith('on') || val.startsWith('javascript:')) el.removeAttribute(attr.name);
        });
      });
      return box.innerHTML;
    },
    formatTime(value) {
      if (!value) return '--';
      const date = new Date(String(value).replace(' ', 'T'));
      if (Number.isNaN(date.getTime())) return String(value).replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '');
      const pad = n => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }
  }
};
</script>
<style scoped>.notice-card{background:#fff;border-radius:18px;padding:22px;min-height:220px;box-shadow:0 6px 18px rgba(75,52,0,.07)}.notice-card h2{font-size:24px;margin:0 0 18px;color:#211507}.notice-content{line-height:1.9;color:#3a2a0f;font-size:15px;background:#fff8e8;border:1px solid #eee2c7;border-radius:12px;padding:12px;word-break:break-word;overflow:hidden}.notice-card time{display:block;text-align:right;color:#8b806d;margin-top:28px}.rich-text >>> p{margin:0 0 10px}.rich-text >>> p:last-child{margin-bottom:0}.rich-text >>> img{max-width:100%;height:auto;border-radius:8px}.rich-text >>> a{color:#d39b2c;text-decoration:underline}.rich-text >>> ul,.rich-text >>> ol{padding-left:20px}.rich-text >>> table{max-width:100%;border-collapse:collapse}.rich-text >>> td,.rich-text >>> th{border:1px solid #e5d7b8;padding:6px}</style>
